import { DateHelper } from "../util/dateHelper";
import { Deserializable } from "./deserializable";

export class operationLogEvent implements Deserializable {

  // sender: string;
  // type: string;
  // data: string;
  // date: Date;
  // name: string;
  // value: string;
  // eventType: string;

  // dataActive: string;
  // dataType: string;
  // dataTime: number;
  // dataDate: Date;

  // dateFriendly: string;


  data: string;
  date: Date;
  operation: string;
  operator: string;
  ownerUid: string;
  result: string;
  serial: string;
  dateFriendly: string;

  deserialize(input: any) {

    Object.assign(this, input);

    this.date = DateHelper.parseDate(input.date);
    this.dateFriendly = DateHelper.formatDateTimeFriendly(this.date);

    if (this.serial == "") {
      this.serial = "-";
    }

    return this;
  }

  // public getDescription(): string {

  //   if (this.dataType == "mqtt-connected") {
  //     return "Dissuasore connesso ad Internet";
  //   } if (this.dataType == "boot") {
  //     return "Dissuasore acceso";
  //   } else {
  //     return this.dataType;
  //   }
  // }

  // public getIcon(): string {

  //   if (this.dataType == "mqtt-connected") {
  //     return "wifi";
  //   } else if (this.dataType.includes("error")) {
  //     return "exclamation-triangle";
  //   }
  //   else if (this.dataType == "clients-update" || this.dataType == "client-updated") {

  //     return "user";
  //   }
  //   else if (this.dataType == "boot") {
  //     return "bolt";

  //   } else if (this.dataType == "device-offline" || this.dataType == "device-online") {
  //     return "power-off";

  //   } else if (this.dataType == "mqtt-connected") {
  //     return "network-wired";
  //   }

  //   if (this.type == "event") {
  //     if (this.dataActive) {
  //       return "dot-circle";
  //     }
  //     else {
  //       return "circle";
  //     }
  //   } else {

  //     return "comment";
  //   }
  // }
}
